import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-carpeting',
    templateUrl: './icon-carpeting.component.html'
})
export class IconCarpetingComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    constructor() { }

    ngOnInit() {
    }

}
